(function() {
  'use strict';
    angular.module('dnSecurity')
    .controller('secAuthenticationController', ['$scope','secLoginResource', '$state', 'loginUserService',
    '$transitions', 'secSecurityService','$rootScope', '$cookies','$stateParams','$timeout',
    function($scope, loginResource, $state, loginUserService, $transitions, secSecurityService, $rootScope, $cookies,$stateParams,$timeout) {
      var vm = this;
      vm.model = {username: $cookies.get('userId'), rememberId: !!$cookies.get('userId')};
      vm.submit = submit;
      vm.authenticationFailure = false;


      $rootScope.$on('authenticationChanged', function(undefined, e) {
        if (e.loggedIn === false) {
          $scope.errorControl && $scope.errorControl.showErrors(false);
        }
      });

      vm.logout = $stateParams.allParams.loggedOut;
      vm.sessionTimedOut = $stateParams.allParams.sessionTimedOut;
      vm.lastState = $stateParams.allParams.lastState;
      var watch = $scope.$watch('dnConfirmationMessage', function(val) {
        if (val) {
          if ($stateParams.allParams.showConfirmationMessage) {
            $timeout(function() {
              val.$show($stateParams.allParams.showConfirmationMessage, $stateParams.allParams.type);
            }, 500);
          } else if (vm.sessionTimedOut) {
            secSecurityService.logout();
            $timeout(function() {
              val.$show('Your session has timed out.  Please log in again.', 'warning');
            }, 500);
          }
          watch();
        }
      });
      if ($stateParams.allParams.notAuthorized) {
        vm.authenticationFailure = true;
        vm.errorMessage = 'You are not authorized to access this application.';
      }


      function submit() {
        $scope.errorControl.showErrors(true);
        if (vm.loginForm.$invalid) {
          return;
        }
        vm.running = true;
        vm.logout = false;
        vm.sessionTimedOut = false;
        vm.authenticationFailure = false;
        var userCredentials = _.clone(vm.model);
        loginResource.save(userCredentials).$promise.then(function(data) {
          vm.running = false;
          if (!vm.model.rememberId) {
            $cookies.remove('userId');
          }
          secSecurityService.clearAuthentication();
          if(data.authentication) {
            if (vm.model.rememberId) {
              $cookies.put('userId', vm.model.username, { expires: new Date('2099-01-01')});
            }
            $cookies.put("socketChannelId", data.authentication.socketChannelId, {path: '/', session: true});
            $rootScope.$broadcast('authenticationChanged', {loggedIn: true, lastState: {name: vm.lastState, params: $stateParams.allParams},
              socketChannelId: data.authentication.socketChannelId});

          } else {
            vm.authenticationFailure = true;
            vm.errorMessage = secSecurityService.getAuthenticationErrorMessage(data.exception);
            vm.model.password = '';
            $scope.errorControl.showErrors(false);
          }
        });
      }
    }]);
})();
